import { render, staticRenderFns } from "./modalAlterarDataDeColeta.vue?vue&type=template&id=205f1178"
import script from "./modalAlterarDataDeColeta.vue?vue&type=script&lang=js"
export * from "./modalAlterarDataDeColeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports